import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import image1 from "../../../images/healthcare/healthcare3.webp";
import { Link } from "react-router-dom";
const DigitalHealth = () => {
  const banner = {
    title: "Digital Health",
    image: image1,
  };

  return (
    <>
      <Helmet>
        <title>
          Digital Health — Cylon Technologies – Big Data | Data Analytics |
          Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Digital Health Services </h2>
              <p>
                The digital revolution is not only changing the way we
                communicate but is also offering us more innovative ways of
                monitoring our health & well-being thereby giving us greater
                access to personal data and self-management. Digital Health as
                such has now emerged as one of the most far reaching trends in
                the healthcare industry bringing with it a broad array of
                technologies including mobile health (mHealth), health
                information technology (HIT), wearable devices, telehealth,
                telemedicine services and personalized medicine.
              </p>
              <p>
                The list of technologies within the ambit of digital health is
                quite broad with several of these technologies tightly
                interlinked. By the end of 2017, the digital health industry was
                already worth more than $179.6 billion globally and expected to
                reach $536.6 billion by the end of 2025. It has the potential of
                cutting the healthcare costs by about $7 billion a year in the
                United States itself.
              </p>
              <p>
                Our Expertise in Digital Health Services – Syncing with Reforms
                and Regulations
              </p>
              <p>
                Digital health to succeed requires a high level of coordination
                and interoperability across the various sectors of the
                healthcare industry to ensure that the true benefits of improved
                proactive healthcare can be achieved and sustained.
              </p>
              <p>
                Cylon Technologies advanced analytical technologies is enabled
                by the creation of real-time big data streams with artificial
                Intelligence or AI helping in improving outcomes of our esteemed
                clients to cut costs and increase engagement through our digital
                health services. AI is already being used to automate time
                consuming task (preauthorization) and in helping with diagnostic
                imaging interpretation.
              </p>
              <p>
                Our digital health tools ensure decision makers having the data
                to deliver comprehensive health services for all. The abilities
                of our digital health technologies in improving the
                accessibility, quality and affordability of healthcare services
                has received a major thrust in providing Medicaid Fiscal Agent
                Services that include-
              </p>

              <ul>
                <li>Claims Administration</li>
                <li>Claims data intake</li>
                <li>Prior authorization</li>
                <li>Fraud and abuse</li>
                <li>Claims overflow BPM/workflow</li>
                <li>Medicaid Medical Management</li>
                <li>Health Risk Assessment </li>
                <li>Medicaid Care Management</li>
                <li>Medicaid Back-Office Operations</li>
                <li>Premium billing and reconciliation</li>
                <li>Claims – EOB, check etc</li>
                <li>Advanced Data Analytics</li>
                <li>Operation Dashboards</li>
                <li>
                  Medical Management with predictive health and cost analysis
                </li>
                <li>Centric analysis</li>
              </ul>
            </div>
            <div className="col-md-4">
              <div className="right_content">
                <div className="border-tb mb-5">
                  <h2 className="heading2 mt-0">Offerings</h2>
                  <p>
                    Cylon Technologies innovative solutions in digital health are resulting in giving our renowned customers more information about their health, and more control over their care. It also unlocks never before seen insight into patient health patterns and medication treatment effectiveness that leads to more informed healthcare decisions to everyone involved. Our digital healthcare services had becomes the catalyst for healthcare service providers and as such resulted in outcomes such as-
                  </p>
                  <ul>
                    <li>More engaged patients or customers</li>
                    <li>
                      Optimized Therapies
                    </li>
                    <li>
                      Improved outcomes
                    </li>

                  </ul>
                  <p>
                    With many stakeholders involved in digital health activities including patients, health care practitioners, researchers, medical device firms, as such Cylon technologies has adopted a wide ranging set of policies that are designed to help integrate the burgeoning field of mHealth into clinical practices. We have established the Digital Healthcare Program that seeks to better protect and promote patient healthcare and provides continued regulatory clarity by -
                  </p>
                  <ul>
                    <li>Developing  and Implementing regulatory strategies and policies for digital health technologies and</li>
                    <li>Fostering partnerships/collaborations and enhancing the outreach to digital health customers.
                    </li>
                    <li>Overall, our digital health services are capable of providing people with smart care in a homely environment.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DigitalHealth;
